import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { MoodLogDto, MoodLevel } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';

const moodColors: Record<MoodLevel, string> = {
  [MoodLevel.AWFUL]: '#ff6b6b',
  [MoodLevel.BAD]: '#fa8c16',
  [MoodLevel.OKAY]: '#fadb14',
  [MoodLevel.GOOD]: '#52c41a',
  [MoodLevel.GREAT]: '#1890ff',
};

const moodEmojis: Record<MoodLevel, string> = {
  [MoodLevel.AWFUL]: '😢',
  [MoodLevel.BAD]: '😔',
  [MoodLevel.OKAY]: '😐',
  [MoodLevel.GOOD]: '🙂',
  [MoodLevel.GREAT]: '😄',
};

export const MoodLogShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<MoodLogDto>({ resource: 'mood-logs' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="mood-logs">
      <div style={{ padding: '8px 0' }}>
        <Field label="Mood Log ID">{item.id}</Field>
        <Field label="User ID">{item.userId}</Field>
        <Field label="Mood">
          <Tag
            style={{
              borderColor: moodColors[item.mood] || '#898989',
              color: moodColors[item.mood] || '#898989',
              background: `${moodColors[item.mood] || '#898989'}15`,
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {moodEmojis[item.mood]} {item.mood}
          </Tag>
        </Field>
        {item.energy !== undefined && <Field label="Energy">{item.energy}/5</Field>}
        {item.stress !== undefined && <Field label="Stress">{item.stress}/5</Field>}
        {item.sleep !== undefined && <Field label="Sleep">{item.sleep}/5</Field>}
        {item.notes && <Field label="Notes">{item.notes}</Field>}
        {item.factors && item.factors.length > 0 && (
          <Field label="Factors">
            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              {item.factors.map((factor, idx) => (
                <Tag key={idx} color="blue" style={{ borderRadius: 9999 }}>
                  {factor}
                </Tag>
              ))}
            </div>
          </Field>
        )}
        {item.photoUrl && <Field label="Photo URL">{item.photoUrl}</Field>}
        <Field label="Logged At">{new Date(item.loggedAt).toLocaleString()}</Field>
        <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
        <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
      </div>
    </Show>
  );
};